import { create } from 'zustand';
import cookieInfo from '@alife/bc-cookie-info';
import MTop from '@/common/mtop';

// sku面板数据
const PRODUCT_QUICK_VIEW = 'mtop.alibaba.intl.skyladder.product.detail.asyn.common';

type State = {
  activeProductId: string;
  detailUrl: string;
  module: string;
  channel: string;
  data: {
    [x: string]: DetailTypes.GlobalData;
  };
};

type Action = {
  setActiveProductId: (x: string) => void;
  setDetailUrl: (x: string) => void;
  setModuleChannel: (module: string, channel: string) => void;
  fetch: (params: { productId: string; type?: string }) => void;
};

const QuickView = create<State & Action>((set) => ({
  data: {},
  activeProductId: '',
  detailUrl: '',
  module: '',
  channel: '',
  setModuleChannel: (module, channel) => {
    set({
      module,
      channel,
    });
  },
  setActiveProductId: (activeProductId) => {
    set({
      activeProductId,
    });
  },
  setDetailUrl: (url) => {
    set({
      detailUrl: url,
    });
  },
  fetch: async (params) => {
    const { productId, type = 'skuPanel' } = params;
    const result: DetailTypes.GlobalData = await MTop(PRODUCT_QUICK_VIEW, {
      productId,
      appCountry: 'US',
      providerName: type,
      language: cookieInfo.getBuyerLocale(),
      currency: cookieInfo.getBuyerCurrency() || 'USD',
    });
    set((state) => ({
      activeProductId: productId,
      data: {
        ...state.data,
        [productId]: {
          ...result,
          abtest: {
            pc_detail_fantasy: 'fantasy_po',
          },
        },
      },
    }));
  },
}));

export default QuickView;
